// extracted by mini-css-extract-plugin
export var image = "jV_dr";